export const CROSS_CHECK_STATUSES = {
    match: {
        label: 'Match',
        color: '#1CBB8C',
    },
    no_match: {
        label: 'No Match',
        color: '#EB5757',
    },
    not_available: {
        label: '-',
        color: '#828282',
    },
};

export const getCrossCheckStatusConfig = (status) => (
    CROSS_CHECK_STATUSES[status] || CROSS_CHECK_STATUSES.not_available
);
